export const getVisibleRoleIds = (currentAppRoles = [], selectedAppId) => {
  const appRoles = currentAppRoles?.find(
    (entry) => String(entry?.client_app_id) === String(selectedAppId)
  );

  if (!appRoles || !Array.isArray(appRoles.roles)) return null;

  return appRoles.roles
    .map((role) => (typeof role === "object" ? role?.id : role))
    .filter((roleId) => roleId !== undefined && roleId !== null);
};

export const getVisibleRoles = (
  roles = [],
  currentAppRoles = [],
  selectedAppId,
  assignedRoleIds = [],
  isSuperadmin = false
) => {
  if (isSuperadmin) return roles;

  const appRoles = currentAppRoles?.find(
    (entry) => String(entry?.client_app_id) === String(selectedAppId)
  );
  const storedRoleNames = (appRoles?.roles || [])
    .map((role) => (typeof role === "object" ? role?.name : null))
    .filter(Boolean)
    .map((name) => name.toLowerCase());
  const assignedIds = new Set(assignedRoleIds.map((roleId) => String(roleId)));
  const hasAdminRole =
    storedRoleNames.includes("admin") ||
    roles.some((role) => assignedIds.has(String(role.id)) && role.name === "Admin");

  if (hasAdminRole) return roles;

  return roles.filter((role) => role.name === "Operator");
};
